import {Big as BigDecimal} from 'big.js';


export class Lohnsteuer2026Service {
  // TODO check;



  constructor() {
  }
  private divSR(x: BigDecimal, y: BigDecimal, dp: number, rm: number): BigDecimal {
    const oldDP = (BigDecimal as any).DP;
    const oldRM = (BigDecimal as any).RM;
  
    (BigDecimal as any).DP = dp;
    (BigDecimal as any).RM = rm;
  
    const res = x.div(y);
  
    (BigDecimal as any).DP = oldDP;
    (BigDecimal as any).RM = oldRM;
  
    return res;
  }
  
  /**
   * 1, wenn die Anwendung des Faktorverfahrens gewählt wurden (nur in Steuerklasse IV)
   */
  private af = 1;


  /**
   * Auf die Vollendung des 64. Lebensjahres folgende
   * Kalenderjahr (erforderlich, wenn ALTER1=1)
   */
  private AJAHR = 0;

  /**
   * 1, wenn das 64. Lebensjahr zu Beginn des Kalenderjahres vollendet wurde, in dem
   * der Lohnzahlungszeitraum endet (§ 24 a EStG), sonst = 0
   */
  private ALTER1 = 0;

  /**
   * Merker für die Vorsorgepauschale
   * 0 = der Arbeitnehmer ist in der Arbeitslosenversicherung pflichtversichert; es gilt die allgemeine Beitragsbemessungsgrenze
   * 1 = wenn nicht 0
   */
  private ALV = 0;

  /**
   * eingetragener Faktor mit drei Nachkommastellen
   */
  private f = 1.0;

  /**
   * Jahresfreibetrag für die Ermittlung der Lohnsteuer für die sonstigen Bezüge 
   * sowie für Vermögensbeteiligungen nach § 19a Absatz 1 und 4 EStG nach Maßgabe der 
   * elektronischen Lohnsteuerabzugsmerkmale nach § 39e EStG oder der Eintragung 
   * auf der Bescheinigung für den Lohnsteuerabzug 2026 in Cent (ggf. 0)
   */
  private JFREIB: BigDecimal = new BigDecimal(0);


  /**
   * Jahreshinzurechnungsbetrag für die Ermittlung der Lohnsteuer für die sonstigen Bezüge
   * sowie für Vermögensbeteiligungen nach § 19a Absatz 1 und 4 EStG nach Maßgabe der 
   * elektronischen Lohnsteuerabzugsmerkmale nach § 39e EStG oder der Eintragung auf der 
   * Bescheinigung für den Lohnsteuerabzug 2026 in Cent (ggf. 0)
   */
  private JHINZU: BigDecimal = new BigDecimal(0);


  /**
   * Voraussichtlicher Jahresarbeitslohn ohne sonstige Bezüge (d.h. auch ohne 
   * die zu besteuernden Vorteile bei Vermögensbeteiligungen,
   * § 19a Absatz 4 EStG) in Cent. 
   * Anmerkung: Die Eingabe dieses Feldes (ggf. 0) ist erforderlich bei Eingaben zu sonstigen 
   * Bezügen (Feld SONSTB). 
   * Sind in einem vorangegangenen Abrechnungszeitraum bereits sonstige Bezüge gezahlt worden,
   * so sind sie dem voraussichtlichen Jahresarbeitslohn hinzuzurechnen. Gleiches gilt für zu 
   * besteuernde Vorteile bei Vermögensbeteiligungen (§ 19a Absatz 4 EStG).
   */
  private JRE4: BigDecimal = new BigDecimal(0);


  /**
   * In JRE4 enthaltene Entschädigungen nach § 24 Nummer 1 EStG und zu besteuernde
   * Vorteile bei Vermögensbeteiligungen (§ 19a Absatz 4 EStG) in Cent
   */
  private JRE4ENT: BigDecimal = new BigDecimal(0);


  /**
   * In JRE4 enthaltene Versorgungsbezüge in Cent (ggf. 0)
   */
  private JVBEZ: BigDecimal = new BigDecimal(0);


  /**
   * Merker für die Vorsorgepauschale
   * 0 = der Arbeitnehmer ist in der gesetzlichen Rentenversicherung oder einer 
   * berufsständischen Versorgungseinrichtung pflichtversichert oder bei Befreiung von der 
   * Versicherungspflicht freiwillig versichert; es gilt die allgemeine Beitragsbemessungsgrenze
   * 
   * 1 = wenn nicht 0
   */
  private KRV = 0;


  /**
   * Kassenindividueller Zusatzbeitragssatz bei einem gesetzlich krankenversicherten Arbeitnehmer 
   * in Prozent (bspw. 2,50 für 2,50 %) mit 2 Dezimalstellen. 
   * Es ist der volle Zusatzbeitragssatz anzugeben. Die Aufteilung in Arbeitnehmer- und Arbeitgeber-
   * anteil erfolgt im Programmablauf.
   */
  private KVZ: BigDecimal = new BigDecimal(0);


  /**
   * Lohnzahlungszeitraum:
   * 1 = Jahr
   * 2 = Monat
   * 3 = Woche
   * 4 = Tag
   */
  private LZZ = 0;


  /**
   * Der als elektronisches Lohnsteuerabzugsmerkmal für den Arbeitgeber nach § 39e EStG festgestellte 
   * oder in der Bescheinigung für den Lohnsteuerabzug 2026 eingetragene Freibetrag für den 
   * Lohnzahlungszeitraum in Cent
   */
  private LZZFREIB: BigDecimal = new BigDecimal(0);


  /**
   * Der als elektronisches Lohnsteuerabzugsmerkmal für den Arbeitgeber nach § 39e EStG festgestellte 
   * oder in der Bescheinigung für den Lohnsteuerabzug 2026 eingetragene Hinzurechnungsbetrag für den
   * Lohnzahlungszeitraum in Cent
   */
  private LZZHINZU: BigDecimal = new BigDecimal(0);

  /**
   * Nicht zu besteuernde Vorteile bei Vermögensbeteiligungen 
   * (§ 19a Absatz 1 Satz 4 EStG) in Cent
   */
  private MBV: BigDecimal = new BigDecimal(0);


  /**
   * Dem Arbeitgeber mitgeteilte Beiträge des Arbeitnehmers für eine private
   * Basiskranken- bzw. Pflege-Pflichtversicherung im Sinne des 
   * § 10 Absatz 1 Nummer 3 EStG in Cent; der Wert ist unabhängig vom Lohnzahlungszeitraum 
   * immer als Monatsbetrag anzugeben
   */
  private PKPV: BigDecimal = new BigDecimal(0);

  /**
   * Arbeitgeberzuschuss für eine private Basiskranken- bzw. Pflege-Pflichtversicherung im 
   * Sinne des § 10 Absatz 1 Nummer 3 EStG in Cent; der Wert ist unabhängig vom 
   * Lohnzahlungszeitraum immer als Monatsbetrag anzugeben
   */
  private PKPVAGZ: BigDecimal = new BigDecimal(0);

  /**
   * Krankenversicherung:
   * 0 = gesetzlich krankenversicherte Arbeitnehmer
   * 1 = ausschließlich privat krankenversicherte Arbeitnehmer
   */
  private PKV = 0;
  private PVA = new BigDecimal(0);


  /**
   * 1, wenn bei der sozialen Pflegeversicherung die Besonderheiten in Sachsen zu berücksichtigen sind bzw. 
   * zu berücksichtigen wären, sonst 0.
   */
  private PVS = 0;


  /**
   * 1, wenn er der Arbeitnehmer den Zuschlag zur sozialen Pflegeversicherung 
   * zu zahlen hat, sonst 0.
   */
  private PVZ = 0;

  /**
   * Religionsgemeinschaft des Arbeitnehmers lt. elektronischer Lohnsteuerabzugsmerkmale oder der 
   * Bescheinigung für den Lohnsteuerabzug 2026 (bei keiner Religionszugehörigkeit = 0)
   */
  private R = 0;


  /**
   * Steuerpflichtiger Arbeitslohn für den Lohnzahlungszeitraum vor Berücksichtigung des 
   * Versorgungsfreibetrags und des Zuschlags zum Versorgungsfreibetrag, des Altersentlastungsbetrags 
   * und des als elektronisches Lohnsteuerabzugsmerkmal festgestellten oder in der Bescheinigung für 
   * den Lohnsteuerabzug 2026 für den Lohnzahlungszeitraum eingetragenen Freibetrags bzw. 
   * Hinzurechnungsbetrags in Cent
   */
  private RE4: BigDecimal = new BigDecimal(0);


  /**
   * Sonstige Bezüge einschließlich zu besteuernde Vorteile bei Vermögensbeteiligungen und Sterbegeld bei Versorgungsbezügen sowie 
   * Kapitalauszahlungen/Abfindungen, in Cent (ggf. 0)
   */
  private SONSTB: BigDecimal = new BigDecimal(0);


  /**
   * In SONSTB enthaltene Entschädigungen nach § 24 Nummer 1 EStG sowie zu besteuernde Vorteile bei Vermögensbeteiligungen (§ 19a
   * Absatz 4 EStG), in Cent
   */
  private SONSTENT: BigDecimal = new BigDecimal(0);

  /**
   * Sterbegeld bei Versorgungsbezügen sowie Kapitalauszahlungen/Abfindungen
   * (in SONSTB enthalten), in Cent
   */
  private STERBE = new BigDecimal(0);


  /**
   * Steuerklasse:
   * 1 = I
   * 2 = II
   * 3 = III
   * 4 = IV
   * 5 = V
   * 6 = VI
   */
  private STKL = 0;


  /**
   * In RE4 enthaltene Versorgungsbezüge in Cent (ggf. 0) ggf. unter Berücksichtigung 
   * einer geänderten Bemessungsgrundlage nach  § 19 Absatz 2 Satz 10 und 11 EStG
   */
  private VBEZ: BigDecimal = new BigDecimal(0);


  /**
   * Versorgungsbezug im Januar 2005 bzw. für den ersten vollen Monat, wenn der 
   * Versorgungsbezug erstmalig nach Januar 2005 gewährt  wurde, in Cent
   */
  private VBEZM: BigDecimal = new BigDecimal(0);


  /**
   * Voraussichtliche Sonderzahlungen von Versorgungsbezügen im
   * Kalenderjahr des Versorgungsbeginns bei Versorgungsempfängern
   * ohne Sterbegeld, Kapitalauszahlungen/Abfindungen in Cent
   */
  private VBEZS: BigDecimal = new BigDecimal(0);


  /**
   * In SONSTB enthaltene Versorgungsbezüge einschließlich Sterbegeld in Cent (ggf. 0)
   */
  private VBS: BigDecimal = new BigDecimal(0);


  /**
   * Jahr, in dem der Versorgungsbezug erstmalig gewährt wurde;
   * werden mehrere Versorgungsbezüge gezahlt, wird aus
   * Vereinfachungsgründen für die Berechnung das Jahr des ältesten
   * erstmaligen Bezugs herangezogen; auf die Möglichkeit der
   * getrennten Abrechnung verschiedenartiger Bezüge (§ 39e Absatz 5a
   * EStG) wird im Übrigen verwiesen
   */
  private VJAHR = 0;


  /**
   * Zahl der Freibeträge für Kinder (eine Dezimalstelle, nur bei Steuerklassen
   * I, II, III und IV)
   */
  private ZKF: BigDecimal = new BigDecimal(0);

  /**
   * Zahl der Monate, für die Versorgungsbezüge gezahlt werden [nur
   * erforderlich bei Jahresberechnung (LZZ = 1)]
   */
  private ZMVB = 0;


  /* Output variables */

  /**
   * Bemessungsgrundlage fuer die Kirchenlohnsteuer in Cents
   */
  private BK: BigDecimal = new BigDecimal(0);

  /**
   * Bemessungsgrundlage der sonstigen Bezüge für die Kirchenlohnsteuer in Cent.
   * Hinweis: Negativbeträge, die aus nicht zu besteuernden Vorteilen bei 
   * Vermögensbeteiligungen (§ 19a Absatz 1 Satz 4 EStG) resultieren, mindern BK 
   * (maximal bis 0). Der Sonderausgabenabzug für tatsächlich erbrachte Vorsorgeaufwendungen 
   * im Rahmen der Veranlagung zur Einkommensteuer bleibt unberührt.
   */
  private BKS: BigDecimal = new BigDecimal(0);

  /**
   * Fuer den Lohnzahlungszeitraum einzubehaltende Lohnsteuer in Cents
   */
  private LSTLZZ: BigDecimal = new BigDecimal(0);

  /**
   * Fuer den Lohnzahlungszeitraum einzubehaltender Solidaritaetszuschlag
   * in Cents
   */
  private SOLZLZZ: BigDecimal = new BigDecimal(0);

  /**
   * Solidaritätszuschlag für sonstige Bezüge in Cent.
   * Hinweis: Negativbeträge, die aus nicht zu besteuernden Vorteilen bei
   * Vermögensbeteiligungen (§ 19a Absatz 1 Satz 4 EStG) resultieren,
   * mindern SOLZLZZ (maximal bis 0). Der Sonderausgabenabzug für
   * tatsächlich erbrachte Vorsorgeaufwendungen im Rahmen der
   * Veranlagung zur Einkommensteuer bleibt unberührt.
   */
  private SOLZS: BigDecimal = new BigDecimal(0);

  /**
   * Lohnsteuer für sonstige Bezüge in Cent
   * Hinweis: Negativbeträge, die aus nicht zu besteuernden Vorteilen bei Vermögensbeteiligungen
   * (§ 19a Absatz 1 Satz 4 EStG) resultieren, mindern LSTLZZ (maximal bis 0). Der 
   * Sonderausgabenabzug für tatsächlich erbrachte Vorsorgeaufwendungen im Rahmen der 
   * Veranlagung zur Einkommensteuer bleibt unberührt.
   */
  private STS: BigDecimal = new BigDecimal(0);

  /**
   * Verbrauchter Freibetrag bei Berechnung des laufenden Arbeitslohns, in Cent
   */
  private VFRB: BigDecimal = new BigDecimal(0);

  /**
   * Verbrauchter Freibetrag bei Berechnung des voraussichtlichen Jahresarbeitslohns, in Cent
   */
  private VFRBS1: BigDecimal = new BigDecimal(0);

  /**
   * Verbrauchter Freibetrag bei Berechnung der sonstigen Bezüge, in Cent
   */
  private VFRBS2: BigDecimal = new BigDecimal(0);

  /**
   * Für die weitergehende Berücksichtigung des Steuerfreibetrags nach dem DBA Türkei verfügbares ZVE über
   * dem Grundfreibetrag bei der Berechnung des laufenden Arbeitslohns, in Cent
   */
  private WVFRB: BigDecimal = new BigDecimal(0);

  /**
   * Für die weitergehende Berücksichtigung des Steuerfreibetrags nach dem DBA Türkei verfügbares ZVE über dem Grundfreibetrag
   * bei der Berechnung des voraussichtlichen Jahresarbeitslohns, in Cent
   */
  private WVFRBO: BigDecimal = new BigDecimal(0);

  /**
   * Für die weitergehende Berücksichtigung des Steuerfreibetrags nach dem DBA Türkei verfügbares ZVE
   * über dem Grundfreibetrag bei der Berechnung der sonstigen Bezüge, in Cent
   */
  private WVFRBM: BigDecimal = new BigDecimal(0);

  /* Internal variables */

  /**
   * Altersentlastungsbetrag nach Alterseinkünftegesetz in €,
   * Cent (2 Dezimalstellen)
   */
  private ALTE: BigDecimal = new BigDecimal(0);

  /**
   * Arbeitnehmer-Pauschbetrag/Werbungskosten-Pauschbetrag in Euro
   */
  private ANP: BigDecimal = new BigDecimal(0);

  /**
   * Auf den Lohnzahlungszeitraum entfallender Anteil von Jahreswerten
   * auf ganze Cents abgerundet
   */
  private ANTEIL1: BigDecimal = new BigDecimal(0);

  /**
   * Beitragssatz des Arbeitnehmers zur Arbeitslosenversicherung (4 Dezimalstellen)
   */
  private AVSATZAN: BigDecimal = new BigDecimal(0);

  /**
   * Bemessungsgrundlage für Altersentlastungsbetrag in €, Cent
   * (2 Dezimalstellen)
   */
  private BMG: BigDecimal = new BigDecimal(0);

  /**
   * Beitragsbemessungsgrenze in der gesetzlichen Krankenversicherung 
   * und der sozialen Pflegeversicherung in Euro
   */
  private BBGKVPV: BigDecimal = new BigDecimal(0);

  /**
   * Allgemeine Beitragsbemessungsgrenze in der allgemeinen Rentenversicherung und Arbeitslosenversicherung in Euro
   */
  private BBGRVALV: BigDecimal = new BigDecimal(0);

  /**
   * Differenz zwischen ST1 und ST2 in EURO
   */
  private DIFF: BigDecimal = new BigDecimal(0);

  /**
   * Entlastungsbetrag für Alleinerziehende in Euro
   */
  private EFA: BigDecimal = new BigDecimal(0);

  /**
   * Versorgungsfreibetrag in €, Cent (2 Dezimalstellen)
   */
  private FVB: BigDecimal = new BigDecimal(0);

  /**
   * Versorgungsfreibetrag in €, Cent (2 Dezimalstellen) für die Berechnung
   * der Lohnsteuer für den sonstigen Bezug
   */
  private FVBSO: BigDecimal = new BigDecimal(0);

  /**
   * Zuschlag zum Versorgungsfreibetrag in EURO
   */
  private FVBZ: BigDecimal = new BigDecimal(0);

  /**
   * Zuschlag zum Versorgungsfreibetrag in EURO fuer die Berechnung
   * der Lohnsteuer beim sonstigen Bezug
   */
  private FVBZSO: BigDecimal = new BigDecimal(0);

  /**
   * Grundfreibetrag in Euro
   */
  private GFB: BigDecimal = new BigDecimal(0);

  /**
   * Maximaler Altersentlastungsbetrag in €
   */
  private HBALTE: BigDecimal = new BigDecimal(0);

  /**
   * Massgeblicher maximaler Versorgungsfreibetrag in €
   */
  private HFVB: BigDecimal = new BigDecimal(0);

  /**
   * Massgeblicher maximaler Zuschlag zum Versorgungsfreibetrag in €,Cent
   * (2 Dezimalstellen)
   */
  private HFVBZ: BigDecimal = new BigDecimal(0);

  /**
   * Massgeblicher maximaler Zuschlag zum Versorgungsfreibetrag in €, Cent
   * (2 Dezimalstellen) für die Berechnung der Lohnsteuer für den
   * sonstigen Bezug
   */
  private HFVBZSO: BigDecimal = new BigDecimal(0);

  /**
   * Zwischenfeld zu X für die Berechnung der Steuer nach § 39b
   * Absatz 2 Satz 7 EStG in Euro
   */
  private HOCH: BigDecimal = new BigDecimal(0);

  /**
   * Nummer der Tabellenwerte fuer Versorgungsparameter
   */
  private J = 0;

  /**
   * Jahressteuer nach § 51a EStG, aus der Solidaritaetszuschlag und
   * Bemessungsgrundlage fuer die Kirchenlohnsteuer ermittelt werden in EURO
   */
  private JBMG: BigDecimal = new BigDecimal(0);

  /**
   * Auf einen Jahreslohn hochgerechneter LZZFREIB in €, Cent
   * (2 Dezimalstellen)
   */
  private JLFREIB: BigDecimal = new BigDecimal(0);

  /**
   * Auf einen Jahreslohn hochgerechnete LZZHINZU in €, Cent
   * (2 Dezimalstellen)
   */
  private JLHINZU: BigDecimal = new BigDecimal(0);

  /**
   * Jahreswert, dessen Anteil fuer einen Lohnzahlungszeitraum in
   * UPANTEIL errechnet werden soll in Cents
   */
  private JW: BigDecimal = new BigDecimal(0);

  /**
   * Nummer der Tabellenwerte fuer Parameter bei Altersentlastungsbetrag
   */
  private K = 0;

  /**
   * Summe der Freibetraege fuer Kinder in EURO
   */
  private KFB: BigDecimal = new BigDecimal(0);

  /**
   * Beitragssatz des Arbeitnehmers zur Krankenversicherung
   * (5 Dezimalstellen)
   */
  private KVSATZAN: BigDecimal = new BigDecimal(0);

  /**
   * Kennzahl fuer die Einkommensteuer-Tabellenart:
   * 1 = Grundtarif
   * 2 = Splittingverfahren
   */
  private KZTAB = 0;

  /**
   * Jahreslohnsteuer in EURO
   */
  private LSTJAHR: BigDecimal = new BigDecimal(0);

  /**
   * Zwischenfelder der Jahreslohnsteuer in Cent
   */
  private LSTOSO: BigDecimal = new BigDecimal(0);
  private LSTSO: BigDecimal = new BigDecimal(0);

  /**
   * Mindeststeuer fuer die Steuerklassen V und VI in EURO
   */
  private MIST: BigDecimal = new BigDecimal(0);

  /**
   * Auf einen Jahreswert hochgerechneter Arbeitgeberzuschuss für eine private Basiskranken- 
   * bzw. Pflege-Pflichtversicherung im Sinne des § 10 Absatz 1 Nummer 3 EStG in Euro, Cent (2 Dezimalstellen)
   */
  private PKPVAGZJ: BigDecimal = new BigDecimal(0);

  /**
   * Beitragssatz des Arbeitnehmers zur Pflegeversicherung (6 Dezimalstellen)
   */
  private PVSATZAN: BigDecimal = new BigDecimal(0);

  /**
   * Beitragssatz des Arbeitnehmers in der allgemeinen gesetzlichen Rentenversicherung (4 Dezimalstellen)
   */
  private RVSATZAN: BigDecimal = new BigDecimal(0);

  /**
   * Rechenwert in Gleitkommadarstellung
   */
  private RW: BigDecimal = new BigDecimal(0);

  /**
   * Sonderausgaben-Pauschbetrag in EURO
   */
  private SAP: BigDecimal = new BigDecimal(0);

  /**
   * Freigrenze fuer den Solidaritaetszuschlag in EURO
   */
  private SOLZFREI: BigDecimal = new BigDecimal(0);

  /**
   * Solidaritaetszuschlag auf die Jahreslohnsteuer in EURO, C (2 Dezimalstellen)
   */
  private SOLZJ: BigDecimal = new BigDecimal(0);

  /**
   * Zwischenwert fuer den Solidaritaetszuschlag auf die Jahreslohnsteuer
   * in EURO, C (2 Dezimalstellen)
   */
  private SOLZMIN: BigDecimal = new BigDecimal(0);

  /**
   * Bemessungsgrundlage des Solidaritätszuschlags zur Prüfung der Freigrenze beim Solidaritätszuschlag für sonstige Bezüge in Euro
   */
  private SOLZSBMG: BigDecimal = new BigDecimal(0);

  /**
   * Zu versteuerndes Einkommen für die Ermittlung der
   * Bemessungsgrundlage des Solidaritätszuschlags zur Prüfung der
   * Freigrenze beim Solidaritätszuschlag für sonstige Bezüge in Euro,
   * Cent (2 Dezimalstellen)
   */
  private SOLZSZVE: BigDecimal = new BigDecimal(0);

  /**
   * Tarifliche Einkommensteuer in EURO
   */
  ST: BigDecimal = new BigDecimal(0);

  /**
   * Tarifliche Einkommensteuer auf das 1,25-fache ZX in EURO
   */
  ST1: BigDecimal = new BigDecimal(0);

  /**
   * Tarifliche Einkommensteuer auf das 0,75-fache ZX in EURO
   */
  ST2: BigDecimal = new BigDecimal(0);

  /**
   * Bemessungsgrundlage fuer den Versorgungsfreibetrag in Cents
   */
  VBEZB: BigDecimal = new BigDecimal(0);

  /**
   * Bemessungsgrundlage für den Versorgungsfreibetrag in Cent für
   * den sonstigen Bezug
   */
  VBEZBSO: BigDecimal = new BigDecimal(0);

  /**
   * Zwischenfeld zu X für die Berechnung der Steuer nach § 39b
   * Absatz 2 Satz 7 EStG in Euro
   */
  VERGL: BigDecimal = new BigDecimal(0);

  /**
   * Auf den Höchstbetrag begrenzte Beiträge zur Arbeitslosenversicherung 
   * einschließlich Kranken- und Pflegeversicherung in Euro, Cent (2 Dezimalstellen)
   */
  VSPHB: BigDecimal = new BigDecimal(0);

  /**
   * Vorsorgepauschale mit Teilbeträgen für die Rentenversicherung
   * sowie die gesetzliche Kranken- und soziale Pflegeversicherung nach
   * fiktiven Beträgen oder ggf. für die private Basiskrankenversicherung
   * und private Pflege-Pflichtversicherung in Euro, Cent (2 Dezimalstellen)
   */
  VSP: BigDecimal = new BigDecimal(0);

  /**
   * Vorsorgepauschale mit Teilbeträgen für die Rentenversicherung sowie auf den Höchstbetrag 
   * begrenzten Teilbeträgen für die Arbeitslosen-, Kranken- und Pflegeversicherung in 
   * Euro, Cent (2 Dezimalstellen)
   */
  VSPN: BigDecimal = new BigDecimal(0);

  /**
   * Teilbetrag für die Arbeitslosenversicherung bei der Berechnung der
   * Vorsorgepauschale in Euro, Cent (2 Dezimalstellen)
   */
  VSPALV: BigDecimal = new BigDecimal(0);

  /**
   * Vorsorgepauschale mit Teilbeträgen für die gesetzliche Kranken- und soziale Pflegeversicherung 
   * nach fiktiven Beträgen oder ggf. für die private Basiskrankenversicherung und private 
   * Pflege-Pflichtversicherung in Euro, Cent (2 Dezimalstellen)
   */
  VSPKVPV: BigDecimal = new BigDecimal(0);

  /**
   * Teilbetrag für die Rentenversicherung bei der Berechnung der Vorsorgepauschale 
   * in Euro, Cent (2 Dezimalstellen)
   */
  VSPR: BigDecimal = new BigDecimal(0);

  /**
   * Erster Grenzwert in Steuerklasse V/VI in Euro
   */
  W1STKL5: BigDecimal = new BigDecimal(0);

  /**
   * Zweiter Grenzwert in Steuerklasse V/VI in Euro
   */
  W2STKL5: BigDecimal = new BigDecimal(0);

  /**
   * Dritter Grenzwert in Steuerklasse V/VI in Euro
   */
  W3STKL5: BigDecimal = new BigDecimal(0);

  /**
   * Zu versteuerndes Einkommen gem. § 32a Absatz 1 und 5 EStG in Euro, Cent 
   * (2 Dezimalstellen)
   */
  X: BigDecimal = new BigDecimal(0);

  /**
   * Gem. § 32a Absatz 1 EStG (6 Dezimalstellen)
   */
  Y: BigDecimal = new BigDecimal(0);

  /**
   * Auf einen Jahreslohn hochgerechnetes RE4 in €, C (2 Dezimalstellen)
   * nach Abzug der Freibeträge nach § 39 b Absatz 2 Satz 3 und 4 EStG
   */
  ZRE4: BigDecimal = new BigDecimal(0);

  /**
   * Auf einen Jahreslohn hochgerechnetes RE4 in €, C (2 Dezimalstellen)
   */
  ZRE4J: BigDecimal = new BigDecimal(0);

  /**
   * Auf einen Jahreslohn hochgerechnetes RE4, ggf. nach Abzug der
   * Entschädigungen i.S.d. § 24 Nummer 1 EStG in Euro, Cent
   * (2 Dezimalstellen)
   */
  ZRE4VP: BigDecimal = new BigDecimal(0);

  /**
   * Zwischenfeld zu ZRE4VP für die Begrenzung auf die jeweilige 
   * Beitragsbemessungsgrenze in Euro, Cent (2 Dezimalstellen)
   */
  ZRE4VPR: BigDecimal = new BigDecimal(0);

  /**
   * Feste Tabellenfreibeträge (ohne Vorsorgepauschale) in €, Cent
   * (2 Dezimalstellen)
   */
  ZTABFB: BigDecimal = new BigDecimal(0);
  /**
   * Auf einen Jahreslohn hochgerechnetes (VBEZ abzueglich FVB) in
   * EURO, C (2 Dezimalstellen)
   */
  ZVBEZ: BigDecimal = new BigDecimal(0);

  /**
   * Auf einen Jahreslohn hochgerechnetes VBEZ in €, C (2 Dezimalstellen)
   */
  private ZVBEZJ = new BigDecimal(0);

  /**
   * Zu versteuerndes Einkommen in €, C (2 Dezimalstellen)
   */
  private ZVE = new BigDecimal(0);

  /**
   * Zwischenfelder zu X fuer die Berechnung der Steuer nach § 39b
   * Abs. 2 Satz 7 EStG in €
   */
  ZX: BigDecimal = new BigDecimal(0);
  ZZX: BigDecimal = new BigDecimal(0);

  ZERO: BigDecimal = new BigDecimal(0);
  ZAHL1: BigDecimal = new BigDecimal(1);
  ZAHL2: BigDecimal = new BigDecimal(2);
  ZAHL5: BigDecimal = new BigDecimal(5);
  ZAHL7: BigDecimal = new BigDecimal(7);
  ZAHL12: BigDecimal = new BigDecimal(12);
  ZAHL100: BigDecimal = new BigDecimal(100);
  ZAHL360: BigDecimal = new BigDecimal(360);
  ZAHL500: BigDecimal = new BigDecimal(500);
  ZAHL700: BigDecimal = new BigDecimal(700);
  ZAHL1000: BigDecimal = new BigDecimal(1000);
  ZAHL10000: BigDecimal = new BigDecimal(10000);
  /**
   * Jahreswert der berücksichtigten Beiträge zur privaten Basis-Krankenversicherung und
   * privaten Pflege-Pflichtversicherung (ggf. auch die Mindestvorsorgepauschale) in Cent.
   */
  TAB1: BigDecimal[] = [
    new BigDecimal(0.0),
    new BigDecimal(0.4),
    new BigDecimal(0.384),
    new BigDecimal(0.368),
    new BigDecimal(0.352),
    new BigDecimal(0.336),
    new BigDecimal(0.32),
    new BigDecimal(0.304),
    new BigDecimal(0.288),
    new BigDecimal(0.272),
    new BigDecimal(0.256),
    new BigDecimal(0.24),
    new BigDecimal(0.224),
    new BigDecimal(0.208),
    new BigDecimal(0.192),
    new BigDecimal(0.176),
    new BigDecimal(0.16),
    new BigDecimal(0.152),
    new BigDecimal(0.144),
    new BigDecimal(0.14),
    new BigDecimal(0.136),
    new BigDecimal(0.132),
    new BigDecimal(0.128),
    new BigDecimal(0.124),
    new BigDecimal(0.12),
    new BigDecimal(0.116),
    new BigDecimal(0.112),
    new BigDecimal(0.108),
    new BigDecimal(0.104),
    new BigDecimal(0.1),
    new BigDecimal(0.096),
    new BigDecimal(0.092),
    new BigDecimal(0.088),
    new BigDecimal(0.084),
    new BigDecimal(0.08),
    new BigDecimal(0.076),
    new BigDecimal(0.072),
    new BigDecimal(0.068),
    new BigDecimal(0.064),
    new BigDecimal(0.060),
    new BigDecimal(0.056),
    new BigDecimal(0.052),
    new BigDecimal(0.048),
    new BigDecimal(0.044),
    new BigDecimal(0.04),
    new BigDecimal(0.036),
    new BigDecimal(0.032),
    new BigDecimal(0.028),
    new BigDecimal(0.024),
    new BigDecimal(0.020),
    new BigDecimal(0.016),
    new BigDecimal(0.012),
    new BigDecimal(0.008),
    new BigDecimal(0.004),
    new BigDecimal(0.0)
  ];
  private TAB2: BigDecimal[] = [
    new BigDecimal('0'),
    new BigDecimal('3000'),
    new BigDecimal('2880'),
    new BigDecimal('2760'),
    new BigDecimal('2640'),
    new BigDecimal('2520'),
    new BigDecimal('2400'),
    new BigDecimal('2280'),
    new BigDecimal('2160'),
    new BigDecimal('2040'),
    new BigDecimal('1920'),
    new BigDecimal('1800'),
    new BigDecimal('1680'),
    new BigDecimal('1560'),
    new BigDecimal('1440'),
    new BigDecimal('1320'),
    new BigDecimal('1200'),
    new BigDecimal('1140'),
    new BigDecimal('1080'),
    new BigDecimal('1050'),
    new BigDecimal('1020'),
    new BigDecimal('990'),
    new BigDecimal('960'),
    new BigDecimal('930'),
    new BigDecimal('900'),
    new BigDecimal('870'),
    new BigDecimal('840'),
    new BigDecimal('810'),
    new BigDecimal('780'),
    new BigDecimal('750'),
    new BigDecimal('720'),
    new BigDecimal('690'),
    new BigDecimal('660'),
    new BigDecimal('630'),
    new BigDecimal('600'),
    new BigDecimal('570'),
    new BigDecimal('540'),
    new BigDecimal('510'),
    new BigDecimal('480'),
    new BigDecimal('450'),
    new BigDecimal('420'),
    new BigDecimal('390'),
    new BigDecimal('360'),
    new BigDecimal('330'),
    new BigDecimal('300'),
    new BigDecimal('270'),
    new BigDecimal('240'),
    new BigDecimal('210'),
    new BigDecimal('180'),
    new BigDecimal('150'),
    new BigDecimal('120'),
    new BigDecimal('90'),
    new BigDecimal('60'),
    new BigDecimal('30'),
    new BigDecimal('0')
  ];

  private TAB3: BigDecimal[] = [
    new BigDecimal('0'),
    new BigDecimal('900'),
    new BigDecimal('864'),
    new BigDecimal('828'),
    new BigDecimal('792'),
    new BigDecimal('756'),
    new BigDecimal('720'),
    new BigDecimal('684'),
    new BigDecimal('648'),
    new BigDecimal('612'),
    new BigDecimal('576'),
    new BigDecimal('540'),
    new BigDecimal('504'),
    new BigDecimal('468'),
    new BigDecimal('432'),
    new BigDecimal('396'),
    new BigDecimal('360'),
    new BigDecimal('342'),
    new BigDecimal('324'),
    new BigDecimal('315'),
    new BigDecimal('306'),
    new BigDecimal('297'), 
    new BigDecimal('288'),
    new BigDecimal('279'),
    new BigDecimal('270'),
    new BigDecimal('261'),
    new BigDecimal('252'),
    new BigDecimal('243'),
    new BigDecimal('234'),
    new BigDecimal('225'),
    new BigDecimal('216'),
    new BigDecimal('207'),
    new BigDecimal('198'),
    new BigDecimal('189'),
    new BigDecimal('180'),
    new BigDecimal('171'),
    new BigDecimal('162'),
    new BigDecimal('153'),
    new BigDecimal('144'),
    new BigDecimal('135'),
    new BigDecimal('126'),
    new BigDecimal('117'),
    new BigDecimal('108'),
    new BigDecimal('99'),
    new BigDecimal('90'),
    new BigDecimal('81'),
    new BigDecimal('72'),
    new BigDecimal('63'),
    new BigDecimal('54'),
    new BigDecimal('45'),
    new BigDecimal('36'),
    new BigDecimal('27'),
    new BigDecimal('18'),
    new BigDecimal('9'),
    new BigDecimal('0')
  ];

  private TAB4: BigDecimal[] = [
    new BigDecimal('0.0'),
    new BigDecimal('0.4'),
    new BigDecimal('0.384'),
    new BigDecimal('0.368'),
    new BigDecimal('0.352'),
    new BigDecimal('0.336'),
    new BigDecimal('0.32'),
    new BigDecimal('0.304'),
    new BigDecimal('0.288'),
    new BigDecimal('0.272'),
    new BigDecimal('0.256'),
    new BigDecimal('0.24'),
    new BigDecimal('0.224'),
    new BigDecimal('0.208'),
    new BigDecimal('0.192'),
    new BigDecimal('0.176'),
    new BigDecimal('0.16'),
    new BigDecimal('0.152'),
    new BigDecimal('0.144'),
    new BigDecimal('0.140'),
    new BigDecimal('0.136'),
    new BigDecimal('0.132'),
    new BigDecimal('0.128'),
    new BigDecimal('0.124'),
    new BigDecimal('0.12'),
    new BigDecimal('0.116'),
    new BigDecimal('0.112'),
    new BigDecimal('0.108'),
    new BigDecimal('0.104'),
    new BigDecimal('0.1'),
    new BigDecimal('0.096'),
    new BigDecimal('0.092'),
    new BigDecimal('0.088'),
    new BigDecimal('0.084'),
    new BigDecimal('0.08'),
    new BigDecimal('0.076'),
    new BigDecimal('0.072'),
    new BigDecimal('0.068'),
    new BigDecimal('0.064'),
    new BigDecimal('0.06'),
    new BigDecimal('0.056'),
    new BigDecimal('0.052'),
    new BigDecimal('0.048'),
    new BigDecimal('0.044'),
    new BigDecimal('0.04'),
    new BigDecimal('0.036'),
    new BigDecimal('0.032'),
    new BigDecimal('0.028'),
    new BigDecimal('0.024'),
    new BigDecimal('0.02'),
    new BigDecimal('0.016'),
    new BigDecimal('0.012'),
    new BigDecimal('0.008'),
    new BigDecimal('0.004'),
    new BigDecimal('0.0')
  ];

  private TAB5: BigDecimal[] = [
    new BigDecimal('0'),
    new BigDecimal('1900'),
    new BigDecimal('1824'),
    new BigDecimal('1748'),
    new BigDecimal('1672'),
    new BigDecimal('1596'),
    new BigDecimal('1520'),
    new BigDecimal('1444'),
    new BigDecimal('1368'),
    new BigDecimal('1292'),
    new BigDecimal('1216'),
    new BigDecimal('1140'),
    new BigDecimal('1064'),
    new BigDecimal('988'),
    new BigDecimal('912'),
    new BigDecimal('836'),
    new BigDecimal('760'),
    new BigDecimal('722'),
    new BigDecimal('684'),
    new BigDecimal('665'),
    new BigDecimal('646'),
    new BigDecimal('627'),
    new BigDecimal('608'),
    new BigDecimal('589'),
    new BigDecimal('570'),
    new BigDecimal('551'),
    new BigDecimal('532'),
    new BigDecimal('513'),
    new BigDecimal('494'),
    new BigDecimal('475'),
    new BigDecimal('456'),
    new BigDecimal('437'),
    new BigDecimal('418'),
    new BigDecimal('399'),
    new BigDecimal('380'),
    new BigDecimal('361'),
    new BigDecimal('342'),
    new BigDecimal('323'),
    new BigDecimal('304'),
    new BigDecimal('285'),
    new BigDecimal('266'),
    new BigDecimal('247'),
    new BigDecimal('228'),
    new BigDecimal('209'),
    new BigDecimal('190'),
    new BigDecimal('171'),
    new BigDecimal('152'),
    new BigDecimal('133'),
    new BigDecimal('114'),
    new BigDecimal('95'),
    new BigDecimal('76'),
    new BigDecimal('57'),
    new BigDecimal('38'),
    new BigDecimal('19'),
    new BigDecimal('0')
  ];

  getZTABFB() {
    return this.ZTABFB;
  }

  getKfb() {
    return this.KFB;
  }


  setAf(value: number) {
    this.af = value;
  }

  setAjahr(value: number) {
    this.AJAHR = value;
  }

  setAlter1(value: number) {
    this.ALTER1 = value;
  }

  setAlv(value: number) {
    this.ALV = value;
  }

  setF(value) {
    this.f = value;
  }

  setJfreib(value: BigDecimal) {
    this.JFREIB = value;
  }

  setJhinzu(value: BigDecimal) {
    this.JHINZU = value;
  }

  setJre4(value: BigDecimal) {
    this.JRE4 = value;
  }

  setJvbez(value: BigDecimal) {
    this.JVBEZ = value;
  }

  setKrv(value) {
    this.KRV = value;
  }

  setKvz(value: BigDecimal) {
    this.KVZ = value;
  }

  setLzz(value: number) {
    this.LZZ = value;
  }

  setLzzfreib(value: BigDecimal) {
    this.LZZFREIB = value;
  }

  setLzzhinzu(value: BigDecimal) {
    this.LZZHINZU = value;
  }

  setMbv(value: BigDecimal) {
    this.MBV = value;
  }

  setPkpv(value: BigDecimal) {
    this.PKPV = value;
  }

  setPkpvagz(value: BigDecimal) {
    this.PKPVAGZ = value;
  }

  setPkv(value: number) {
    this.PKV = value;
  }

  setPvs(value: number) {
    this.PVS = value;
  }

  setPvz(value: number) {
    this.PVZ = value;
  }

  setPva(value: BigDecimal) {
    this.PVA = value;
  }

  setR(value: number) {
    this.R = value;
  }

  setRe4(value: BigDecimal) {
    this.RE4 = value;
  }

  setSonstb(value: BigDecimal) {
    this.SONSTB = value;
  }

  setSterbe(value: BigDecimal) {
    this.STERBE = value;
  }

  setStkl(value: number) {
    this.STKL = value;
  }

  setVbez(value: BigDecimal) {
    this.VBEZ = value;
  }

  setVbezm(value: BigDecimal) {
    this.VBEZM = value;
  }

  setVbezs(value: BigDecimal) {
    this.VBEZS = value;
  }

  setVbs(value: BigDecimal) {
    this.VBS = value;
  }

  setVjahr(value: number) {
    this.VJAHR = value;
  }

  setZkf(value: BigDecimal) {
    this.ZKF = value;
  }

  setZmvb(value: number) {
    this.ZMVB = value;
  }

  setJre4ent(value: BigDecimal) {
    this.JRE4ENT = value;
  }

  setSonstent(value: BigDecimal) {
    this.SONSTENT = value;
  }

  getBk() {
    return this.BK;
  }

  getBks() {
    return this.BKS;
  }

  getLstlzz() {
    return this.LSTLZZ;
  }

  getSolzlzz() {
    return this.SOLZLZZ;
  }

  getSolzs() {
    return this.SOLZS;
  }

  getSts() {
    return this.STS;
  }

  /**
   * Lohnsteuer für die Vergütung für mehrjährige Tätigkeit (removed in 2026, returns 0 for compatibility)
   */
  getStv() {
    return new BigDecimal(0);
  }

  /**
   * Solidaritätszuschlag für die Vergütung für mehrjährige Tätigkeit (removed in 2026, returns 0 for compatibility)
   */
  getSolzv() {
    return new BigDecimal(0);
  }

  getVfrb() {
    return this.VFRB;
  }

  getVfrbs1() {
    return this.VFRBS1;
  }

  getVfrbs2() {
    return this.VFRBS2;
  }

  getWvfrb() {
    return this.WVFRB;
  }

  getWvfrbo() {
    return this.WVFRBO;
  }

  getWvfrbm() {
    return this.WVFRBM;
  }

  /**
   * PROGRAMMABLAUFPLAN, PAP Seite 13
   */
  MAIN() {
    this.MPARA();
    this.MRE4JL();
    this.VBEZBSO = new BigDecimal(0);
    this.MRE4();
    this.MRE4ABZ();
    this.MBERECH();
    this.MSONST();
  }

  /**
   * Zuweisung von Werten für bestimmte Steuer- und Sozialversicherungsparameter  PAP Seite 14
   */
  MPARA() {
    // 2026 Werte
    this.BBGRVALV = new BigDecimal('101400');
    this.AVSATZAN = new BigDecimal('0.013');
    this.RVSATZAN = new BigDecimal('0.093');
    this.BBGKVPV = new BigDecimal('69750');

    // 2026 XML: KVSATZAN = (KVZ/2/100) + 0.07
    this.KVSATZAN = this.KVZ.div(this.ZAHL2).div(this.ZAHL100).plus(new BigDecimal('0.07'));

    if (this.PVS === 1) {
      this.PVSATZAN = new BigDecimal('0.023');
    } else {
      this.PVSATZAN = new BigDecimal('0.018');
    }
    if (this.PVZ === 1) {
      this.PVSATZAN = this.PVSATZAN.plus(new BigDecimal('0.006'));
    } else {
      this.PVSATZAN = this.PVSATZAN.minus(this.PVA.times(new BigDecimal('0.0025')));
    }

    this.W1STKL5 = new BigDecimal('14071');
    this.W2STKL5 = new BigDecimal('34939');
    this.W3STKL5 = new BigDecimal('222260');

    this.GFB = new BigDecimal('12348');
    this.SOLZFREI = new BigDecimal('20350');
  }


  /**
   * Ermittlung des Jahresarbeitslohns nach § 39 b Absatz 2 Satz 2 EStG, PAP Seite 15
   */
  MRE4JL() {
    if (this.LZZ === 1) {
      this.ZRE4J = this.divSR(this.RE4, this.ZAHL100, 2, BigDecimal.roundDown);
      this.ZVBEZJ = this.divSR(this.VBEZ, this.ZAHL100, 2, BigDecimal.roundDown);
      this.JLFREIB = this.divSR(this.LZZFREIB, this.ZAHL100, 2, BigDecimal.roundDown);
      this.JLHINZU = this.divSR(this.LZZHINZU, this.ZAHL100, 2, BigDecimal.roundDown);
    } else {
      if (this.LZZ === 2) {
        this.ZRE4J = this.divSR(this.RE4.times(this.ZAHL12), this.ZAHL100, 2, BigDecimal.roundDown);
        this.ZVBEZJ = this.divSR(this.VBEZ.times(this.ZAHL12), this.ZAHL100, 2, BigDecimal.roundDown);
        this.JLFREIB = this.divSR(this.LZZFREIB.times(this.ZAHL12), this.ZAHL100, 2, BigDecimal.roundDown);
        this.JLHINZU = this.LZZHINZU.times(this.ZAHL12).div(this.ZAHL100, 2, BigDecimal.roundDown);
      } else {
        if (this.LZZ === 3) {
          this.ZRE4J = this.divSR(this.RE4.times(this.ZAHL360), this.ZAHL700, 2, BigDecimal.roundDown);
          this.ZVBEZJ = this.divSR(this.VBEZ.times(this.ZAHL360), this.ZAHL700, 2, BigDecimal.roundDown);
          this.JLFREIB = this.divSR(this.LZZFREIB.times(this.ZAHL360), this.ZAHL700, 2, BigDecimal.roundDown);
          this.JLHINZU = this.divSR(this.LZZHINZU.times(this.ZAHL360), this.ZAHL700, 2, BigDecimal.roundDown);
        } else {
          this.ZRE4J = this.divSR(this.RE4.times(this.ZAHL360), this.ZAHL100, 2, BigDecimal.roundDown);
          this.ZVBEZJ = this.divSR(this.VBEZ.times(this.ZAHL360), this.ZAHL100, 2, BigDecimal.roundDown);
          this.JLFREIB = this.divSR(this.LZZFREIB.times(this.ZAHL360), this.ZAHL100, 2, BigDecimal.roundDown);
          this.JLHINZU = this.divSR(this.LZZHINZU.times(this.ZAHL360), this.ZAHL100, 2, BigDecimal.roundDown);
        }
      }
    }
    if (this.af === 0) {
      this.f = 1;
    }
  }

  /**
   * Freibeträge für Versorgungsbezüge, Altersentlastungsbetrag (§ 39b Absatz 2 Satz 3 EStG), PAP Seite 16
   */
  MRE4() {
    if (this.ZVBEZJ.eq(0)) {
      this.FVBZ = new BigDecimal(0);
      this.FVB = new BigDecimal(0);
      this.FVBZSO = new BigDecimal(0);
      this.FVBSO = new BigDecimal(0);
    } else {
      if (this.VJAHR < 2006) {
        this.J = 1;
      } else {
        if (this.VJAHR < 2058) {
          this.J = this.VJAHR - 2004;
        } else {
          this.J = 54;
        }
      }
      if (this.LZZ === 1) {
        this.VBEZB = this.VBEZM.times(new BigDecimal(this.ZMVB)).plus(this.VBEZS);
        this.HFVB = this.TAB2[this.J].div(this.ZAHL12).times(new BigDecimal(this.ZMVB)).round(0, BigDecimal.roundUp);
        this.FVBZ = this.TAB3[this.J].div(this.ZAHL12).times(new BigDecimal(this.ZMVB)).round(0, BigDecimal.roundUp);
      } else {
        this.VBEZB = this.VBEZM.times(this.ZAHL12).plus(this.VBEZS).round(2, BigDecimal.roundDown);
        this.HFVB = this.TAB2[this.J];
        this.FVBZ = this.TAB3[this.J];
      }

      this.FVB = this.VBEZB.times(this.TAB1[this.J]).div(this.ZAHL100).round(2, BigDecimal.roundUp);

      if (this.FVB.cmp(this.HFVB) === 1) {
        this.FVB = this.HFVB;
      }
      if (this.FVB.cmp(this.ZVBEZJ) === 1) {
        this.FVB = this.ZVBEZJ;
      }
      this.FVBSO = this.FVB.plus(this.VBEZBSO.times(this.TAB1[this.J]).div(this.ZAHL100)).round(2, BigDecimal.roundUp);
      if (this.FVBSO.cmp(this.TAB2[this.J]) === 1) {
        this.FVBSO = this.TAB2[this.J];
      }
      this.HFVBZSO = this.VBEZB.plus(this.VBEZBSO).div(this.ZAHL100).minus(this.FVBSO).round(2, BigDecimal.roundDown);
      this.FVBZSO = this.FVBZ.plus(this.VBEZBSO.div(this.ZAHL100)).round(0, BigDecimal.roundUp);
      if (this.FVBZSO.cmp(this.HFVBZSO) === 1) {
        this.FVBZSO = this.HFVBZSO.round(0, BigDecimal.roundUp);
      }
      if (this.FVBZSO.cmp(this.TAB3[this.J]) === 1) {
        this.FVBZSO = this.TAB3[this.J];
      }
      this.HFVBZ = this.VBEZB.div(this.ZAHL100).minus(this.FVB).round(2, BigDecimal.roundDown);
      if (this.FVBZ.cmp(this.HFVBZ) === 1) {
        this.FVBZ = this.HFVBZ.round(0, BigDecimal.roundUp);
      }
    }

    this.MRE4ALTE();
  }

  /**
   * Altersentlastungsbetrag (§ 39b Absatz 2 Satz 3 EStG), PAP Seite 17
   */
  MRE4ALTE() {
    if (this.ALTER1 === 0) {
      this.ALTE = new BigDecimal(0);
    } else {
      if (this.AJAHR < 2006) {
        this.K = 1;
      } else {
        if (this.AJAHR < 2058) {
          this.K = this.AJAHR - 2004;
        } else {
          this.K = 54;
        }
      }
      this.BMG = this.ZRE4J.minus(this.ZVBEZJ);
      this.ALTE = this.BMG.times(this.TAB4[this.K]).round(0, BigDecimal.roundUp);

      this.HBALTE = this.TAB5[this.K];
      if (this.ALTE.cmp(this.HBALTE) === 1) {
        this.ALTE = this.HBALTE;
      }
    }
  }


  /**
   * Ermittlung des Jahresarbeitslohns nach Abzug der Freibeträge nach § 39 b Absatz 2 Satz 3 und 4 EStG, PAP Seite 20
   */
  MRE4ABZ() {
    this.ZRE4 = this.ZRE4J.minus(this.FVB).minus(this.ALTE).minus(this.JLFREIB).plus(this.JLHINZU).round(2, BigDecimal.roundDown);

    if (this.ZRE4.cmp(this.ZERO) === -1) {
      this.ZRE4 = new BigDecimal(0);
    }
    this.ZRE4VP = this.ZRE4J;
    this.ZVBEZ = this.ZVBEZJ.minus(this.FVB).round(2, BigDecimal.roundDown);
    if (this.ZVBEZ.cmp(this.ZERO) === -1) {
      this.ZVBEZ = new BigDecimal(0);
    }
  }

  /**
   * Berechnung fuer laufende Lohnzahlungszeitraueme Seite 21
   */
  MBERECH() {
    this.MZTABFB();
    this.VFRB = this.ANP.plus(this.FVB.plus(this.FVBZ)).times(this.ZAHL100).round(0, BigDecimal.roundDown);
    this.MLSTJAHR();
    this.WVFRB = this.ZVE.minus(this.GFB).times(this.ZAHL100).round(0, BigDecimal.roundDown);
    if (this.WVFRB.cmp(this.ZERO) === -1) {
      this.WVFRB = new BigDecimal(0);
    }

    this.LSTJAHR = this.ST.times(new BigDecimal(this.f)).round(0, BigDecimal.roundDown);
    this.UPLSTLZZ();
    if (this.ZKF.cmp(this.ZERO) === 1) {
      this.ZTABFB = this.ZTABFB.plus(this.KFB);

      this.MRE4ABZ();
      this.MLSTJAHR();
      this.JBMG = this.ST.times(new BigDecimal(this.f)).round(0, BigDecimal.roundDown);
    } else {
      this.JBMG = this.LSTJAHR;
    }
    this.MSOLZ();
  }

  /**
   * Ermittlung der festen Tabellenfreibeträge (ohne Vorsorgepauschale), PAP Seite 22
   */
  MZTABFB() {
    this.ANP = new BigDecimal(0);
    if (this.ZVBEZ.cmp(this.ZERO) >= 0 && this.ZVBEZ.cmp(this.FVBZ) === -1) {
      this.FVBZ = new BigDecimal(this.ZVBEZ.longValue());
    }
    if (this.STKL < 6) {
      if (this.ZVBEZ.cmp(this.ZERO) === 1) {
        if (this.ZVBEZ.minus(this.FVBZ).cmp(new BigDecimal(102)) === -1) {
          this.ANP = this.ZVBEZ.minus(this.FVBZ).round(0, BigDecimal.roundUp);
        } else {
          this.ANP = new BigDecimal(102);
        }
      }
    } else {
      this.FVBZ = new BigDecimal(0);
      this.FVBZSO = new BigDecimal(0);
    }
    if (this.STKL < 6) {
      if (this.ZRE4.cmp(this.ZVBEZ) === 1) {
        if (this.ZRE4.minus(this.ZVBEZ).cmp(new BigDecimal(1230)) === -1) {
          this.ANP = this.ANP.plus(this.ZRE4).minus(this.ZVBEZ).round(0, BigDecimal.roundUp);
        } else {
          this.ANP = this.ANP.plus(new BigDecimal(1230));
        }
      }
    }
    this.KZTAB = 1;
    if (this.STKL === 1) {
      this.SAP = new BigDecimal(36);
      this.KFB = this.ZKF.times(new BigDecimal('9756')).round(0, BigDecimal.roundDown);
    } else {
      if (this.STKL === 2) {
        this.EFA = new BigDecimal(4260);
        this.SAP = new BigDecimal(36);
        this.KFB = this.ZKF.times(new BigDecimal('9756')).round(0, BigDecimal.roundDown);
      } else {
        if (this.STKL === 3) {
          this.KZTAB = 2;
          this.SAP = new BigDecimal(36);
          this.KFB = this.ZKF.times(new BigDecimal('9756')).round(0, BigDecimal.roundDown);
        } else {
          if (this.STKL === 4) {
            this.SAP = new BigDecimal(36);
            this.KFB = this.ZKF.times(new BigDecimal('4878')).round(0, BigDecimal.roundDown);
          } else {
            if (this.STKL === 5) {
              this.SAP = new BigDecimal(36);
              this.KFB = new BigDecimal(0);
            } else {
              this.KFB = new BigDecimal(0);
            }
          }
        }
      }
    }
    this.ZTABFB = this.EFA.plus(this.ANP).plus(this.SAP).plus(this.FVBZ).round(2, BigDecimal.roundDown);
  }

  /**
   * Ermittlung Jahreslohnsteuer, PAP Seite 23
   */
  MLSTJAHR() {
    this.UPEVP();
    this.ZVE = this.ZRE4.minus(this.ZTABFB).minus(this.VSP);
    this.UPMLST();
  }

  /**
   * PAP Seite 24
   */
  UPLSTLZZ() {
    this.JW = this.LSTJAHR.times(this.ZAHL100);
    this.UPANTEIL();
    this.LSTLZZ = this.ANTEIL1;
  }

  /**
   * Ermittlung der Jahreslohnsteuer aus dem Einkommensteuertarif. PAP Seite 25
   */
  UPMLST() {
    if (this.ZVE.cmp(this.ZAHL1) === -1) {
      this.ZVE = new BigDecimal(0);
      this.X = new BigDecimal(0);
    } else {
      this.X = this.ZVE.div(new BigDecimal(this.KZTAB)).round(0, BigDecimal.roundDown);
    }
    if (this.STKL < 5) {
      this.UPTAB26();
    } else {
      this.MST5_6();
    }
  }

  /**
   * Vorsorgepauschale (§ 39b Absatz 2 Satz 5 Nummer 3 EStG) PAP Seite 26
   */
  UPEVP() {
    if (this.KRV === 1) {
      this.VSPR = new BigDecimal(0);
    } else {
      if (this.ZRE4VP.cmp(this.BBGRVALV) === 1) {
        this.ZRE4VPR = this.BBGRVALV;
      } else {
        this.ZRE4VPR = this.ZRE4VP;
      }
      this.VSPR = this.ZRE4VPR.times(this.RVSATZAN).round(2, BigDecimal.roundDown);
    }
    this.MVSPKVPV();
    if (this.ALV === 1) {
      // NOP
    } else {
      if (this.STKL === 6) {
        // NOP
      } else {
        this.MVSPHB();
      }
    }
  }

  /**
   * Vorsorgepauschale (§ 39b Absatz 2 Satz 5 Nummer 3 Buchstaben b bis d EStG), PAP Seite 27
   */
  MVSPKVPV() {
    if (this.ZRE4VP.cmp(this.BBGKVPV) === 1) {
      this.ZRE4VPR = this.BBGKVPV;
    } else {
      this.ZRE4VPR = this.ZRE4VP;
    }
    if (this.PKV > 0) {
      if (this.STKL === 6) {
        this.VSPKVPV = new BigDecimal(0);
      } else {
        this.PKPVAGZJ = this.PKPVAGZ.times(this.ZAHL12).div(this.ZAHL100).round(2, BigDecimal.roundDown);
        this.VSPKVPV = this.PKPV.times(this.ZAHL12).div(this.ZAHL100).round(2, BigDecimal.roundDown);
        this.VSPKVPV = this.VSPKVPV.minus(this.PKPVAGZJ);
        if (this.VSPKVPV.cmp(this.ZERO) === -1) {
          this.VSPKVPV = new BigDecimal(0);
        }
      }
    } else {
      this.VSPKVPV = this.ZRE4VPR.times(this.KVSATZAN.plus(this.PVSATZAN)).round(2, BigDecimal.roundDown);
    }
    this.VSP = this.VSPKVPV.plus(this.VSPR).round(2, BigDecimal.roundDown);

  }

  /**
   * Höchstbetragsberechnung zur Arbeitslosenversicherung (§ 39b Absatz 2 Satz 5 Nummer 3 Buchstabe e EStG), PAP Seite 28
   */
  MVSPHB() {
    if (this.ZRE4VP.cmp(this.BBGRVALV) === 1) {
      this.ZRE4VPR = this.BBGRVALV;
    } else {
      this.ZRE4VPR = this.ZRE4VP;
    }
    this.VSPALV = this.AVSATZAN.times(this.ZRE4VPR).round(2, BigDecimal.roundDown);
    this.VSPHB = this.VSPALV.plus(this.VSPKVPV).round(2, BigDecimal.roundDown);
    if (this.VSPHB.cmp(new BigDecimal(1900)) === 1) {
      this.VSPHB = new BigDecimal(1900);
    }
    this.VSPN = this.VSPR.plus(this.VSPHB).round(2, BigDecimal.roundDown);

    if (this.VSPN.cmp(this.VSP) === 1) {
      this.VSP = this.VSPN;
    }
  }

  /**
   * Lohnsteuer fuer die Steuerklassen V und VI (§ 39b Absatz 2 Satz 7 EStG), PAP Seite 29
   */
  MST5_6() {
    this.ZZX = this.X;
    if (this.ZZX.cmp(this.W2STKL5) === 1) {
      this.ZX = this.W2STKL5;
      this.UP5_6();
      if (this.ZZX.cmp(this.W3STKL5) === 1) {
        this.ST = this.ST.plus(this.W3STKL5.minus(this.W2STKL5).times(new BigDecimal('0.42'))).round(0, BigDecimal.roundDown);
        this.ST = this.ST.plus(this.ZZX.minus(this.W3STKL5).times(new BigDecimal('0.45'))).round(0, BigDecimal.roundDown);
      } else {
        this.ST = this.ST.plus(this.ZZX.minus(this.W2STKL5).times(new BigDecimal('0.42'))).round(0, BigDecimal.roundDown);
      }
    } else {
      this.ZX = this.ZZX;
      this.UP5_6();
      if (this.ZZX.cmp(this.W1STKL5) === 1) {
        this.VERGL = this.ST;
        this.ZX = this.W1STKL5;
        this.UP5_6();
        this.HOCH = this.ST.plus(this.ZZX.minus(this.W1STKL5).times(new BigDecimal('0.42'))).round(0, BigDecimal.roundDown);
        if (this.HOCH.cmp(this.VERGL) === -1) {
          this.ST = this.HOCH;
        } else {
          this.ST = this.VERGL;
        }
      }
    }
  }

  /**
   * Unterprogramm zur Lohnsteuer fuer die Steuerklassen V und VI (§ 39b Absatz 2 Satz 7 EStG), PAP Seite 30
   */
  UP5_6() {
    this.X = this.ZX.times(new BigDecimal('1.25')).round(0, BigDecimal.roundDown);
    this.UPTAB26();
    this.ST1 = this.ST;
    this.X = this.ZX.times(new BigDecimal('0.75')).round(0, BigDecimal.roundDown);
    this.UPTAB26();
    this.ST2 = this.ST;
    this.DIFF = this.ST1.minus(this.ST2).times(this.ZAHL2);
    this.MIST = this.ZX.times(new BigDecimal('0.14')).round(0, BigDecimal.roundDown);
    if (this.MIST.cmp(this.DIFF) === 1) {
      this.ST = this.MIST;
    } else {
      this.ST = this.DIFF;
    }
  }

  /**
   * Solidaritaetszuschlag, PAP Seite 31
   */
  MSOLZ() {
    this.SOLZFREI = this.SOLZFREI.times(new BigDecimal(this.KZTAB));
    if (this.JBMG.cmp(this.SOLZFREI) === 1) {
      this.SOLZJ = this.JBMG.times(new BigDecimal('5.5')).div(this.ZAHL100).round(2, BigDecimal.roundDown);
      this.SOLZMIN = this.JBMG.minus(this.SOLZFREI).times(new BigDecimal('11.9')).div(this.ZAHL100).round(2, BigDecimal.roundDown);
      if (this.SOLZMIN.cmp(this.SOLZJ) === -1) {
        this.SOLZJ = this.SOLZMIN;
      }

      this.JW = this.SOLZJ.times(this.ZAHL100).round(0, BigDecimal.roundDown);
      this.UPANTEIL();
      this.SOLZLZZ = this.ANTEIL1;
    } else {
      this.SOLZLZZ = new BigDecimal(0);
    }
    if (this.R > 0) {
      this.JW = this.JBMG.times(this.ZAHL100);
      this.UPANTEIL();
      this.BK = this.ANTEIL1;
    } else {
      this.BK = new BigDecimal(0);
    }
  }

  /**
   * Anteil von Jahresbetraegen fuer einen LZZ (§ 39b Absatz 2 Satz 9 EStG), PAP Seite 32
   */
  UPANTEIL() {
    if (this.LZZ === 1) {
      this.ANTEIL1 = this.JW;
    } else {
      if (this.LZZ === 2) {
        this.ANTEIL1 = this.JW.div(this.ZAHL12, 0, BigDecimal.roundDown);
      } else {
        if (this.LZZ === 3) {
          this.ANTEIL1 = this.JW.times(this.ZAHL7).div(this.ZAHL360, 0, BigDecimal.roundDown);
        } else {
          this.ANTEIL1 = this.JW.div(this.ZAHL360, 0, BigDecimal.roundDown);
        }
      }
    }
  }

  /**
   * Berechnung sonstiger Bezuege nach § 39b Absatz 3 Sätze 1 bis 8 EStG, PAP Seite 33
   */
  MSONST() {
    this.LZZ = 1;
    if (this.ZMVB === 0) {
      this.ZMVB = 12;
    }
    if (this.SONSTB.cmp(this.ZERO) === 0 && this.MBV.cmp(this.ZERO) === 0) {
      this.LSTSO = new BigDecimal(0);
      this.STS = new BigDecimal(0);
      this.SOLZS = new BigDecimal(0);
      this.BKS = new BigDecimal(0);
    } else {
      this.MOSONST();
      this.ZRE4J = this.divSR(this.JRE4.plus(this.SONSTB), this.ZAHL100, 2, BigDecimal.roundDown);
      this.ZVBEZJ = this.divSR(this.JVBEZ.plus(this.VBS), this.ZAHL100, 2, BigDecimal.roundDown);
      this.VBEZBSO = this.STERBE;
      this.MRE4SONST();
      this.MLSTJAHR();
      this.WVFRBM = this.ZVE.minus(this.GFB).times(this.ZAHL100).round(2, BigDecimal.roundDown);
      if (this.WVFRBM.cmp(this.ZERO) === -1) {
        this.WVFRBM = new BigDecimal(0);
      }
      this.LSTSO = this.ST.times(this.ZAHL100);
      // lt. PAP: "Hinweis: negative Zahlen werden nach ihrem Betrag gerundet!"
      this.STS = this.LSTSO.minus(this.LSTOSO).times(new BigDecimal(this.f))
        .div(this.ZAHL100, 0, BigDecimal.roundDown).times(this.ZAHL100);
      this.STSMIN();
    }
  }

  /**
   * PAP Seite 34
   */
  STSMIN() {
    if (this.STS.cmp(this.ZERO) === -1) {
      if (this.MBV.cmp(this.ZERO) === 0) {
        // NOP
      } else {
        this.LSTLZZ = this.LSTLZZ.plus(this.STS);
        if (this.LSTLZZ.cmp(this.ZERO) === -1) {
          this.LSTLZZ = new BigDecimal(0);
        }
        this.SOLZLZZ = this.SOLZLZZ.plus(this.STS.times(new BigDecimal('5.5').div(this.ZAHL100))).round(0, BigDecimal.roundDown);
        if (this.SOLZLZZ.cmp(this.ZERO) === -1) {
          this.SOLZLZZ = new BigDecimal(0);
        }
        this.BK = this.BK.plus(this.STS);
        if (this.BK.cmp(this.ZERO) === -1) {
          this.BK = new BigDecimal(0);
        }
      }
      this.STS = new BigDecimal(0);
      this.SOLZS = new BigDecimal(0);
    } else {
      this.MSOLZSTS();
    }
    if (this.R > 0) {
      this.BKS = this.STS;
    } else {
      this.BKS = new BigDecimal(0);
    }
  }

  /**
   * Berechnung des SolZ auf sonstige Bezüge, PAP Seite 35
   */
  MSOLZSTS() {
    if (this.ZKF.cmp(this.ZERO) === 1) {
      this.SOLZSZVE = this.ZVE.minus(this.KFB);
    } else {
      this.SOLZSZVE = this.ZVE;
    }
    // Using ZAHL1 (which equals BigDecimal.ONE) as per XML specification
    if (this.SOLZSZVE.cmp(this.ZAHL1) === -1) {
      this.SOLZSZVE = new BigDecimal(0);
      this.X = new BigDecimal(0);
    } else {
      this.X = this.SOLZSZVE.div(new BigDecimal(this.KZTAB), 0, BigDecimal.roundDown);
    }
    if (this.STKL < 5) {
      this.UPTAB26();
    } else {
      this.MST5_6();
    }
    this.SOLZSBMG = this.ST.times(new BigDecimal(this.f)).round(0, BigDecimal.roundDown);
    if (this.SOLZSBMG.cmp(this.SOLZFREI) === 1) {
      this.SOLZS = this.STS.times(new BigDecimal('5.5')).div(this.ZAHL100, 0, BigDecimal.roundDown);
    } else {
      this.SOLZS = new BigDecimal(0);
    }
  }

  /**
   * Sonderberechnung ohne sonstige Bezüge für Berechnung bei sonstigen Bezügen, PAP Seite 36
   */
  MOSONST() {
    this.ZRE4J = this.JRE4.div(this.ZAHL100).round(2, BigDecimal.roundDown);
    this.ZVBEZJ = this.JVBEZ.div(this.ZAHL100).round(2, BigDecimal.roundDown);
    this.JLFREIB = this.JFREIB.div(this.ZAHL100, 2, BigDecimal.roundDown);
    this.JLHINZU = this.JHINZU.div(this.ZAHL100, 2, BigDecimal.roundDown);
    this.MRE4();
    this.MRE4ABZ();
    this.ZRE4VP = this.ZRE4VP.minus(this.JRE4ENT.div(this.ZAHL100));
    this.MZTABFB();
    this.VFRBS1 = this.ANP.plus(this.FVB.plus(this.FVBZ)).times(this.ZAHL100).round(2, BigDecimal.roundDown);
    this.MLSTJAHR();
    this.WVFRBO = this.ZVE.minus(this.GFB).times(this.ZAHL100).round(2, BigDecimal.roundDown);
    if (this.WVFRBO.cmp(this.ZERO) === -1) {
      this.WVFRBO = new BigDecimal(0);
    }
    this.LSTOSO = this.ST.times(this.ZAHL100);
  }

  /**
   * Sonderberechnung mit sonstigen Bezüge für Berechnung bei sonstigen Bezügen, PAP Seite 37
   */
  MRE4SONST() {
    this.MRE4();
    this.FVB = this.FVBSO;
    this.MRE4ABZ();
    this.ZRE4VP = this.ZRE4VP.plus(this.MBV.div(this.ZAHL100))
      .minus(this.JRE4ENT.div(this.ZAHL100)).minus(this.SONSTENT.div(this.ZAHL100));
    this.FVBZ = this.FVBZSO;
    this.MZTABFB();
    this.VFRBS2 = this.ANP.plus(this.FVB).plus(this.FVBZ).times(this.ZAHL100).minus(this.VFRBS1);
  }

  /**
   * Tarifliche Einkommensteuer §32a EStG, PAP Seite 38
   */
  UPTAB26() {
    if (this.X.cmp(this.GFB.plus(this.ZAHL1)) === -1) {
      this.ST = new BigDecimal(0);
    } else {
      if (this.X.cmp(new BigDecimal('17800')) === -1) {
        this.Y = this.X.minus(this.GFB).div(this.ZAHL10000, 6, BigDecimal.roundDown);
        this.RW = this.Y.times(new BigDecimal('914.51'));
        this.RW = this.RW.plus(new BigDecimal('1400'));
        this.ST = this.RW.times(this.Y).round(0, BigDecimal.roundDown);
      } else {
        if (this.X.cmp(new BigDecimal('69879')) === -1) {
          this.Y = this.X.minus(new BigDecimal('17799')).div(this.ZAHL10000, 6, BigDecimal.roundDown);
          this.RW = this.Y.times(new BigDecimal('173.1'));
          this.RW = this.RW.plus(new BigDecimal('2397'));
          this.RW = this.RW.times(this.Y);
          this.ST = this.RW.plus(new BigDecimal('1034.87')).round(0, BigDecimal.roundDown);
        } else {
          if (this.X.cmp(new BigDecimal('277826')) === -1) {
            this.ST = this.X.times(new BigDecimal('0.42')).minus(new BigDecimal('11135.63')).round(0, BigDecimal.roundDown);
          } else {
            this.ST = this.X.times(new BigDecimal('0.45')).minus(new BigDecimal('19470.38')).round(0, BigDecimal.roundDown);
          }
        }
      }
    }
    this.ST = this.ST.times(new BigDecimal(this.KZTAB));
  }

}

